<template>
    <div class="modal fade" id="appMgrManagedConfigurationBundleArrayModal" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv">
                <div class="modal-header modal-header-scv-cmn">
                    <div class="modal-header-text-box-scv">
                        <div class="modal-header-text-scv">
                            <template v-if="bAddMode">
                                追加
                            </template>
                            <template v-else>
                                編集
                            </template>
                        </div>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div class="app-mgr-managed-conf-table">
                        <template v-if="show">
                            <div style="margin: 0px 16px;">
                                <AppMgrManagedConfiguration ref="configuration" :readonly="false" :list="list" :listSetting="listSetting" />
                            </div>
                        </template>
                    </div>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-blue" @click="onOK">OK</button>
                            <button type="button" class="btn-scv-white" data-bs-dismiss="modal" style="margin-left: 40px;">キャンセル</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { cloneDeep } from 'lodash';
    import $ from "jquery";
    import AppMgrManagedConfiguration from '@/components/Mobile/AndroidAppDist/AppMgrManagedConfiguration.vue'
    import { LoadingUtil } from '@/util/LoadingUtil'
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        components: {
            AppMgrManagedConfiguration,
        },
        emits: [
            /*
             * OKボタン押下
             * @param[in] { [key: string]: any } : 設定が有効なデータ(cloneDeep済み)
             */
            'onOK'
        ],
    })

    export default class AppMgrManagedConfigurationBundleArrayModal extends Vue {
        // 発行済みID
        private static modalIDNumber = 0;
        // 自身のID
        private myModalIDNumber = 0;

        // 画面モード
        private bAddMode = true;

        // 表示中かどうか(開いたタイミングでmountedが走るようにv-ifで表示/非表示を管理する)
        private show = false;

        // propsよりセッターの方が何かと便利そう
        private list: Array<schema.AMAPI_ManagedProperty> = new Array<schema.AMAPI_ManagedProperty>();        // 管理設定情報一覧
        private listSetting: { [key: string]: any } = [];       // 設定が有効なデータ
        private bundleArrayKey = "";    // 表示中のBundleArrayのキー

        /**
         * @brief   created
         */
        public created(): void {
            // 発行済みIDをインクリメントして他のメッセージダイアログとIDが重複しないようにする
            AppMgrManagedConfigurationBundleArrayModal.modalIDNumber += 1;
            this.myModalIDNumber = AppMgrManagedConfigurationBundleArrayModal.modalIDNumber;
        }

        /**
         * @brief	mounted
         * @note    インスタンスが DOM 要素にマウントされた後
         * @return	なし
         */
        public mounted(): void {
            $('#appMgrManagedConfigurationBundleArrayModal').attr('id', "appMgrManagedConfigurationBundleArrayModal" + this.myModalIDNumber);

            const el = document.getElementById("appMgrManagedConfigurationBundleArrayModal" + this.myModalIDNumber);
            if(null != el) {
                // 画面が開いた時の処理
                el.addEventListener('show.bs.modal', () => {
                    LoadingUtil.Start();
                    // ローディング画面を出すために少しあとでshowする
                    window.setTimeout(() => {
                        this.show = true;
                    }, 0);                       
                });

                el.addEventListener('shown.bs.modal', () => {
                    LoadingUtil.Stop();
                });

                // 画面が閉じた時の処理
                el.addEventListener('hide.bs.modal', () => {
                    this.show = false;
                });
            }
        }

        /**
         * @brief   割り振られたIDを取得
         */
        public GetID(): string {
            return 'appMgrManagedConfigurationBundleArrayModal' + this.myModalIDNumber;
        }

        /**
         * @brief   割り振られたIDを取得
         */
        public Set(list: Array<schema.AMAPI_ManagedProperty>, listSetting: { [key: string]: any }, bundleArrayKey: string, bAddMode: true): void {
            this.list = list;
            this.listSetting = listSetting;
            this.bundleArrayKey = bundleArrayKey;
            this.bAddMode = bAddMode;
        }
        
        /**
         * @brief	OKボタン
         */
        private onOK(): void {
            // 設定を画面から取得
            const refObj: any = this.$refs;
            this.$emit('onOK', cloneDeep(refObj.configuration.getSetting()), this.bundleArrayKey, this.bAddMode);
            BootstrapUtil.hideModal("appMgrManagedConfigurationBundleArrayModal" + this.myModalIDNumber);
        }
    }
</script>

<style scoped>
    .app-mgr-managed-conf-table {
        border-style: solid;
        border-width: 1px;
        border-color: #cdd7eb;
        overflow: auto;
        min-height: 240px;
        max-height: 600px;
        width: 928px;
    }
</style>
